export default __webpack_public_path__ + "static/lick-mat-31ff57842de57988d77f2defe9025a40.png";